import React from "react";
import { getTrueClasses } from "../../../helpers";
import "./index.scss";

const EmptySpace = ({ isShowWebinarNativeBanner }) => (
  <section
    className={getTrueClasses(
      "GCL-ES",
      isShowWebinarNativeBanner && "GCL-ES_WNB"
    )}
  />
);
export default EmptySpace;
